module.exports = __webpack_public_path__ + "img/antes_despues_140.f96867aa.png";